import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { ACTION_GET } from '../utils/AxiosActions'
import "./Loading.css";

const Share = () => {
    const { shareId } = useParams(); // 获取路由参数
    const { getIdTokenClaims } = useAuth0();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const checkAndRedirect = async () => {
            if (localStorage.getItem('user')) {
                let user = JSON.parse(localStorage.getItem('user'));
                if (!user?.is_follow) {
                    window.location.href = process.env.REACT_APP_LINE_ADD_URL;
                    return;
                }
            }

            try {
                const idTokenClaim = await getIdTokenClaims();
                const apiUrl = process.env.REACT_APP_API_URL;
                let url = `${apiUrl}/api/fdcpcrm/getUrl/${shareId}`;
                let config = {
                    headers: {
                        Authorization: idTokenClaim.__raw
                    }
                };

                const result = await ACTION_GET(url, config);
                if (result?.target_url) {
                    window.location.href = result.target_url;
                }
            } catch (error) {
                console.error("Error fetching card:", error);
            } finally {
                setLoading(false);
            }
        };

        checkAndRedirect();
    }, [shareId, getIdTokenClaims]);

    return (
        <div className="share-wrapper">
            {loading && (
                <div className="loading-container">
                    <p>Loading...</p>
                </div>
            )}
        </div>
    );
};

export default Share;
